import React from 'react'

type HeadingSize = 'sm' | 'md' | 'lg';
type FontWeight = 'light' | 'normal' | 'medium' | 'semibold' | 'bold';

const sizeClasses = {
  sm: 'text-lg',
  md: 'text-xl',
  lg: 'text-title-sm',
} as const;

const weightClasses = {
  light: 'font-light',
  normal: 'font-normal',
  medium: 'font-medium',
  semibold: 'font-semibold',
  bold: 'font-bold',
} as const;

interface HeadingProps {
  children: React.ReactNode;
  className?: string;
  size?: HeadingSize;
  weight?: FontWeight;
}

export const Heading1 = ({ children, className = "", size = 'lg', weight = 'bold' }: HeadingProps) => (
  <h1 className={`text-black dark:text-white ${sizeClasses[size]} ${weightClasses[weight]} ${className}`}>{children}</h1>
)

export const Heading2 = ({ children, className = "", size = 'md', weight = 'semibold' }: HeadingProps) => (
  <h2 className={`text-black dark:text-white ${sizeClasses[size]} ${weightClasses[weight]} ${className}`}>{children}</h2>
)

export const Heading3 = ({ children, className = "", size = 'md', weight = 'medium' }: HeadingProps) => (
  <h3 className={`text-black dark:text-white ${sizeClasses[size]} ${weightClasses[weight]} ${className}`}>{children}</h3>
)

export const Heading4 = ({ children, className = "", size = 'sm', weight = 'medium' }: HeadingProps) => (
  <h4 className={`text-black dark:text-white ${sizeClasses[size]} ${weightClasses[weight]} ${className}`}>{children}</h4>
)
